export const COL_WIDTH = 150;
export const COL_GAP = 16;
export const CELL_PADDING = 4;
export const MIN_ROW_HEIGHT = 56;
export const MAX_ROW_HEIGHT = 88;
export const DEFAULT_PEDIGREE_DEPTH = 4;

// Maximum rendered columns to prevent crashing
export const MAX_PEDIGREE_DEPTH = 8;

// Ancestor generations requested from the REST GetPedigree endpoint. The
// endpoint defaults to 3 (subject + 3), which stops short of the default
// visible depth, so the "Show more generations" toggle never appears and
// deeper ancestors never load. 5 matches the public GraphQL pedigree path.
export const PEDIGREE_FETCH_GENERATIONS = 5;

// Per-depth font sizes; depths >4 fall back to the depth-4 entry.
export const NAME_SIZE: Record<number, string> = {
  0: '13px',
  1: '12px',
  2: '11px',
  3: '10px',
  4: '10px',
};
export const IDENT_SIZE: Record<number, string> = {
  0: '11px',
  1: '11px',
  2: '10px',
  3: '9px',
  4: '9px',
};

export const SCROLL_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export type ScrollDirection =
  (typeof SCROLL_DIRECTION)[keyof typeof SCROLL_DIRECTION];
